<template>
  <div>
    <div class="credit-box">
      <div class="c-box">
        <label>CREDITS:</label>
        <div class="value">
          <span v-if="!cLoading">{{ credits }}</span>
          <i class="fas fa-spinner fa-spin" v-else></i>
        </div>
        <div :class="['refresh', {disabled:cLoading}]" @click="getCredits"><i class="fas fa-sync"></i></div>
      </div>
    </div>

    <table v-if="!isMobile">
      <thead>
        <th>{{ $t('consumer.promoCodes.date') }}</th>
        <th>{{ $t('consumer.promoCodes.code') }}</th>
        <th>{{ $t('consumer.promoCodes.value') }}</th>
        <th>{{ $t('consumer.promoCodes.type') }}</th>
        <th>{{ $t('consumer.promoCodes.expires') }}</th>
        <th>{{ $t('consumer.promoCodes.amountUsed') }}</th>
      </thead>
      <tbody>
        <tr v-for="promoCode in promoCodes" v-show="promoCodes.length > 0">
          <td>{{ promoCode.date }}</td>
          <td class="code">{{ promoCode.code }}</td>
          <td>${{ toFixed(promoCode.value) }}</td>
          <td>{{ promoCode.type }}</td>
          <td>{{ promoCode.expires }}</td>
          <td>${{ toFixed(promoCode.redeemedAmount) }}</td>
        </tr>

        <tr v-show="loading">
          <td colspan="6" class="table-block">
              <i class="fa fa-circle-notch fa-spin"></i>
              {{ $t('consumer.promoCodes.loading') }}
          </td>
        </tr>

        <tr v-show="promoCodes.length === 0 && !loading">
          <td colspan="6" class="table-block">
            {{ $t('consumer.promoCodes.emptyState') }}
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else>
      <div v-if="promoCodes.length > 0">
        <div class="cards" v-for="(promoCode, i) in promoCodes" :key="i">
          <div class="card">
            <div class="title card-header">
              <div class="time">{{ promoCode.date }}</div>
            </div>
            <div class="title">
              <span class="label">Promo Code:</span>
              <div class="value">{{ promoCode.code ? promoCode.code : '--'}}</div>
            </div>
            <div class="title">
              <span class="label">Value:</span>
              <div class="value">${{ toFixed(promoCode.value) }}</div>
            </div>
            <div class="title">
              <span class="label">Type:</span>
              <div class="value">{{ promoCode.type }}</div>
            </div>
            <div class="title">
              <span class="label">Expires:</span>
              <div class="value">{{ promoCode.expires }}</div>
            </div>
            <div class="title">
              <span class="label">Amount Used:</span>
              <div class="value">${{ toFixed(promoCode.redeemedAmount) }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        {{ $t('consumer.promoCodes.emptyState') }}
      </div>
    </div>
  </div>
</template>

<script>
import ApiPromoCodes from '../../modules/api/consumer/promo-codes'

export default {
  name: 'promoCodes',
  props: ['conId', 'isMobile'],
  data () {
    return {
      loading: false,
      credits: 0,
      cLoading: false
    }
  },
  computed: {
    promoCodes () {
      return this.$store.state.consumer.promoCodes.list
    },
    isMax () {
      return this.$store.state.consumer.promoCodes.isMax
    }
  },
  methods: {
    init () {
      this.$store.commit('consumer/resetPromoCodes')
      this.$store.commit('consumer/setPromoCodesIsMax', false)
      this.$store.commit('consumer/setPromoCodesCurrentPage', 0)

      this.getPromoCodes()
      this.getCredits()
    },
    getPromoCodes () {
      let self = this
      if (self.isMax || self.loading) { return }

      self.loading = true
      ApiPromoCodes.getPromoCodes(self, self.conId, function () {
        self.loading = false
      })
    },
    getCredits () {
      let self = this
      if (self.cLoading) return
      self.cLoading = true
      self.$sdk.get('/consumer/' + self.conId + '/credits', {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.cLoading = false
        if (r.credits) self.credits = r.credits
      })
    },
    toFixed (value) {
      return parseFloat(value).toFixed(2)
    }
  },
  watch: {
    conId: function (value) {
      this.init()
    },
    isMobile: function (value) {
      this.init()
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.credit-box{
  display: flex;
  justify-content: flex-end
}
.c-box{
  border: 1px solid #ccc;
  background: #f3f3f3;
  display: flex;
  line-height: 1;
  align-items: center;

  label{
    font-size: 13px;
    color: #111;
    padding: 0 5px;
    letter-spacing: .6px;
  }
  .value{
    background: #fff;
    padding: 7px 10px;
    text-align: center;
    font-weight: 600;
  }
  .refresh{
    padding: 7px 10px;
    background: #5da4ed;
    color: #fff;
    cursor: pointer;
    
    &:hover{
      background: #71b0f0;
    }
    &.disabled{
      background: #eee;
      cursor: default;
    }
  }
}

table{
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;
        color: #555;

        &.code{ font-weight: 600; }
        &.empty-state{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;
        }
      }
    }
  }
}
@media only screen and (max-width: 430px) {
  .cards {
    .card {
      border: 1px solid #ccc;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;

      > div {
        margin-bottom: 3px;
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
          .time {
            font-size: 12px;
            color: #777;
            word-spacing: 5px;
          }
      }

      .title {
        display: flex;
        align-items: center;
      }


      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Consumer/PromoCodes.vue